import React from "react";
import DataManagementTemplate from "../../../components/templates/DataManagementTemplate";
import { TenantsViewModel } from "../../../viewmodels/setup/tenants/TenantsViewModel";
import { useEffect } from "react";
export default function Tenants() {
  const {
    columns,
    tenants,
    loading,
    pagination,
    onSearch,
    onPageChange,
    headerButtons,
    emptyMessage,
    fetchTenants,
  } = TenantsViewModel();

  useEffect(() => {
    fetchTenants(pagination.page, "");
    // eslint-disable-next-line
  }, []);

  return (
    <DataManagementTemplate
      title="Tenants"
      description="Manage tenant organizations and their account settings."
      columns={columns}
      cardContent
      data={tenants}
      headerButtons={headerButtons}
      loading={loading}
      pagination={pagination}
      onSearch={onSearch}
      onPageChange={onPageChange}
      emptyMessage={emptyMessage}
      searchPlaceholder="Search tenants..."
    />
  );
}
